var map = {
	"./8_Load_Balancing_Algorithms_for_Modern_Systems.mdx": [
		"addc",
		"chunk-2d213cd8"
	],
	"./AboutMe.mdx": [
		"0c40"
	],
	"./Agile_&_Scrum_Practices.mdx": [
		"7619",
		"chunk-2d0d723d"
	],
	"./Breaking_Down_Applications_by_Business_Capabilities.mdx": [
		"e70b",
		"chunk-2d225f1a"
	],
	"./Check_your_Web_App_health_with_Lighthouse.mdx": [
		"505c",
		"chunk-2d0c739f"
	],
	"./Event-Driven_Architecture_for_Scalable_Systems.mdx": [
		"2cb5",
		"chunk-71d294bf"
	],
	"./Exploring_Sorting_Algorithms_in_JavaScript.mdx": [
		"5262",
		"chunk-35a70555"
	],
	"./Exploring_Well_Known_CSS_Layouts.mdx": [
		"9e6f",
		"chunk-2953b902"
	],
	"./HTML_and_Semantics_Building_Meaningful_Web_Content.mdx": [
		"9bd3",
		"chunk-4a31005c"
	],
	"./Hobbies.mdx": [
		"cd7b"
	],
	"./Introduction_to_Algorithms.mdx": [
		"8a72",
		"chunk-78cdc384"
	],
	"./Introduction_to_Software_Engineering_Management.mdx": [
		"b290",
		"chunk-2d20f01d"
	],
	"./Leadership_and_Team_Management_for_Engineering.mdx": [
		"1b9a",
		"chunk-2d0b5e4f"
	],
	"./Monolithic_vs_Microservices_Architectures.mdx": [
		"c761",
		"chunk-2d2176e5"
	],
	"./Progressive_Web_Applications_in_2021.mdx": [
		"d2b3",
		"chunk-2d21ddd5"
	],
	"./Save_money_and_time_with_a_headless_CMS.mdx": [
		"bc55",
		"chunk-2d21a797"
	],
	"./Service_worker_caching_strategies.mdx": [
		"57b4",
		"chunk-2d0c932a"
	],
	"./The_Power_of_Efficiency_Big_O_Analysis.mdx": [
		"0dc8",
		"chunk-4e65855e"
	],
	"./Unlocking_the_Potential_of_Engineering_Teams.mdx": [
		"03bc",
		"chunk-2d0a3e7a"
	],
	"./Wrap_any_rest_API_with_GraphQL_from_the_frontend.mdx": [
		"240e",
		"chunk-2d0b24ed"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "b782";
module.exports = webpackAsyncContext;